import React, { memo, useEffect } from 'react';

import { Screen, useNavigation } from '@betty/navigation';

import { useTranslation } from '@betty/i18n';
import Notifications from '../components/Notifications/Notifications';

function NotificationsScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('account');

  useEffect(() => {
    navigation.setOptions({ title: t('notificationsTitle') });
  }, [navigation, t]);

  return (
    <Screen>
      <Notifications />
    </Screen>
  );
}

export default memo(NotificationsScreen);
